// Fake strategist data
export const FAKE_STRATEGISTS = {
  "strategist_1": {
    id: "strategist_1",
    name: "Carlos Méndez",
    title: "Senior Investment Strategist",
    type: "manager",
    experience: "15 years",
    bio: "Expert in technical analysis and risk management. Carlos has helped thousands of investors optimize their portfolios.",
    email: "carlos.mendez@blackbird.com",
    phone: "+34 912 34 56 78",
    expertise: ["Technical Analysis", "Risk Management", "Derivatives", "Options"],
    image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Carlos"
  },
  "strategist_2": {
    id: "strategist_2",
    name: "Elena García",
    title: "Quantitative Analyst",
    type: "personal",
    experience: "12 years",
    bio: "Expert in quantitative modeling and machine learning applied to finance. Elena develops data-driven strategies.",
    email: "elena.garcia@blackbird.com",
    phone: "+34 912 34 56 79",
    expertise: ["Machine Learning", "Quantitative Analysis", "Python", "Big Data"],
    image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Elena"
  },
  "strategist_3": {
    id: "strategist_3",
    name: "Miguel Rodríguez",
    title: "Portfolio Manager",
    type: "manager",
    experience: "18 years",
    bio: "Portfolio manager with extensive international market experience. Specialist in diversification and asset allocation.",
    email: "miguel.rodriguez@blackbird.com",
    phone: "+34 912 34 56 80",
    expertise: ["Asset Allocation", "International Markets", "Fixed Income", "Equities"],
    image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Miguel"
  },
};
